import BrowserNotSupported from "./components/BrowserNotSupported";
export default BrowserNotSupported;
